export default __webpack_public_path__ + "static/media/aral-logo.ccb37a36.svg";